import React from 'react';
import { useSelector } from "react-redux";
import { QuickStartIcon } from '@util/svgicon';
import BookmarkIcon from '@images/mission/bookmark.svg';
import { useRouter } from 'next/router';
import { useAuth } from "@context";

const TAB_QUICK_START = 'quickstart';
const TAB_SAVED_BOTS = 'savedbots';

const DashboardMenuBar = () => {
    const router = useRouter();
    const { apiLoading } = useAuth();
    const fullLicenceMetaData = useSelector((state) => state.minting.fullLicenceMetaData);

    const handleTabClick = async (tabNumber) => {
        if (tabNumber === TAB_QUICK_START) {
            router.push(`/quickstart`)
        } else if (tabNumber === TAB_SAVED_BOTS) {
            router.push(`/savedbots`)
        }
    };

    const handleClickTestDrive = () => {
        router.push(`/testdrive`)
    }

    const openJoinOurDiscord = () => {
        window.open('https://discord.gg/7k3mPF759Z');
    }

    return (
        <>
            {(!apiLoading && fullLicenceMetaData?.life_point <= 0) ?
                <div className='flex items-start gap-[16px]'>
                    <button className='flex justify-center w-[172px] h-[56px] pl-[16px] pr-[24px] py-0 items-center gap-[8px] rounded-[32px] bg-[#25BD66]' onClick={openJoinOurDiscord} >
                        <p className='text-[#FFF] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                            Join Discord
                        </p>
                    </button>
                    <button
                        onClick={handleClickTestDrive}
                        className='flex justify-center w-[172px] h-[56px] pl-[16px] pr-[24px] py-0 items-center gap-[8px] rounded-[32px] bg-[#25BD66]'
                    >
                        <p className='text-[#FFF] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                            Test Drive
                        </p>
                    </button>
                </div>
                :
                (!apiLoading && (fullLicenceMetaData?.statusOfPass === 'minting' || fullLicenceMetaData?.life_point)) &&
                <div className='flex items-start gap-[16px]'>
                    <button className='flex justify-center w-[174px] h-[56px] pl-[16px] pr-[24px] py-0 items-center gap-[8px] rounded-[32px] bg-[#FAFAFA]' onClick={() => handleTabClick(TAB_SAVED_BOTS)}>
                        <span>
                            <img src={BookmarkIcon} alt='bookmark' />
                        </span>
                        <p className='text-[#000] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                            Saved Bots
                        </p>
                    </button>
                    <button className='flex justify-center w-[172px] h-[56px] pl-[16px] pr-[24px] py-0 items-center gap-[8px] rounded-[32px] bg-[#25BD66]' onClick={() => handleTabClick(TAB_QUICK_START)}>
                        <span>
                            <QuickStartIcon />
                        </span>
                        <p className='text-[#FFF] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                            Quick Start
                        </p>
                    </button>
                </div>
            }
        </>
    )
}

export default DashboardMenuBar;